export default __webpack_public_path__ + "static/media/TheNewYear_16.20fbdfcd.png";